<script setup lang="ts">
import { cn } from '@/lib/utils'
import { Loader, Search } from 'lucide-vue-next'
import { ListboxFilter, type ListboxFilterProps, useForwardProps } from 'reka-ui'
import { type HTMLAttributes } from 'vue'
import { useCommand } from '.'
import { reactiveOmit } from '@vueuse/core'

defineOptions({
    inheritAttrs: false,
})

const props = withDefaults(
    defineProps<
        ListboxFilterProps & {
            class?: HTMLAttributes['class']
            searching?: boolean
        }
    >(),
    {
        searching: false,
    }
)

const delegatedProps = reactiveOmit(props, 'class')

const forwardedProps = useForwardProps(delegatedProps)

const { filterState } = useCommand()
</script>

<template>
    <div class="flex items-center border-b px-3" cmdk-input-wrapper>
        <Search v-if="!searching" class="mr-2 h-3 w-3 shrink-0 opacity-50" />
        <Loader v-if="searching" class="mr-2 h-3 w-3 shrink-0 opacity-50 animate-spin" />
        <ListboxFilter
            v-bind="{ ...forwardedProps, ...$attrs }"
            v-model="filterState.search"
            auto-focus
            :class="
                cn(
                    'flex h-10 w-full rounded-md bg-transparent py-3 text-xs outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
                    props.class
                )
            "
        />
    </div>
</template>
